<template>

	<el-container>
		<!-- <el-header>
			<vheader v-on:LoginBox="LoginBox"></vheader>
		</el-header> -->
		<el-main class="main-bg" >
			<el-container class="container user-container ">

				<el-main class="right-column center-bg" style="overflow: hidden;" >
					<router-view v-on:LoginBox="LoginBox"></router-view>
				</el-main>
				<!-- <el-aside class="left-column">
					<user-menu v-on:LoginBox="LoginBox"></user-menu>
				</el-aside> -->
			</el-container>
		</el-main>
		<!-- <el-footer height="176px" style="background-color: #645e5e;">
			<vfooter></vfooter>
		</el-footer> -->
		<LoginBox ref="LoginBox"></LoginBox>
	</el-container>

</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Menu from '@/components/views/user/Menu.vue'
import LoginBox from '@/components/LoginBox'
import FloatButton from '@/components/FloatButton'
import { globalMixin } from '@/mixin.js';
import { mapGetters } from 'vuex'
export default {
    mixins: [globalMixin],
	name: 'UserLayout',
	components: {
		'vheader': Header,
		'vfooter': Footer,
		'userMenu': Menu,
		'LoginBox' : LoginBox,
		'FloatButton' : FloatButton,
	},
	methods: {
		LoginBox(args){
			this.$refs.LoginBox[args.methods]();
		},

	},
    computed: {
		...mapGetters({
			config: 'config',
			user: 'user',
			web: 'web',
		}),
    },
	created() {
	

	},
	mounted() {

	},
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/layouts/User.vue